import { createStore } from "vuex";
import GolfClub from "./modules/GolfClub";

export default createStore({
    modules: {
        GolfClub,
    },
});
